import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowOrderSummaryTemplate } from "themes/application/facility-order-new-flow-order-summary/pages";
import { FacilityOrderNewFlowOrderSummaryViewStore } from "application/facility-order-new-flow-order-summary/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowOrderSummaryViewStore(rootStore), "facilityOrderNewFlowOrderSummaryViewStore")
@observer
class FacilityOrderNewFlowOrderSummary extends React.Component {
	render() {
		return <FacilityOrderNewFlowOrderSummaryTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowOrderSummary;